<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show.sync="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'md'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="row">
      <div class="col-md-12 mb-3">
        <label class="form-label">Tipo de paciente</label>
        <select class="form-control" v-model="localTypePatient">
          <option value="" disabled>Seleccione</option>
          <option value="particular">PARTICULAR</option>
          <option value="eps">EPS</option>
        </select>
      </div>

      <div class="col-md-12 mb-3" v-if="localTypePatient === 'eps'">
        <label class="form-label">Aseguradora</label>
        <select class="form-control" v-model="localInsurance">
          <option value="" disabled>Seleccione aseguradora</option>
          <option v-for="ins in insurances" :key="ins.id" :value="ins.id">
            {{ ins.name }}
          </option>
        </select>
      </div>
    </div>

    <template #footer>
      <button @click="mtdClose" class="btn btn-danger btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      &nbsp;
      <button class="btn btn-success btn-sm" @click="mtdSave">
        <i class="fas fa-save" />&nbsp; Guardar
      </button>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";

export default {
  name: "c-modal-edit-type-patient",
  components: { CModal },
  props: {
    title: { type: String, default: "Editar tipo de paciente" },
    boo_modal: Boolean,
    insurances: { type: Array, default: () => [] },
    item: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      localTypePatient: "",
      localInsurance: null,
    };
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) this.mtdInit();
    },
  },
  methods: {
    mtdInit() {
      this.localTypePatient = this.item.type_patient === 'eps' ? 'eps' : 
                              this.item.type_patient === 'particular' ? 'particular' : '';
      this.localInsurance = this.item.insurance_id || null;
    },
    mtdSave() {
      if (!this.localTypePatient) {
        return this.$emit("mtdWarning", "Seleccione el tipo de paciente");
      }
      if (this.localTypePatient === 'eps' && !this.localInsurance) {
        return this.$emit("mtdWarning", "Seleccione una aseguradora");
      }
      this.$emit("mtdSaveTypePatient", {
        sale: this.item.id,
        type_patient: this.localTypePatient,
        insurance_id: this.localTypePatient === 'eps' ? this.localInsurance : null,
      });
    },
    mtdClose() {
      this.$emit("mtdCloseModalTypePatient");
    },
  },
};
</script>